import React from "react"
import LayersBanner from "./mappedin-layers.banner"
import LayersGraphiclist from "./mappedin-layers.graphiclist"
import useLayersImages from "../../../components/developer-tools/useLayersImages"

export default function MappedinLayers() {
  const layersImages = useLayersImages()
  return (
    <>
      <LayersBanner />
      <LayersGraphiclist assets={layersImages} />
    </>
  )
}
